import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "input-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "input-field__insidelabel"
}
const _hoisted_4 = {
  key: 0,
  class: "multiselect-multiple-label"
}
const _hoisted_5 = {
  key: 1,
  class: "multiselect-multiple-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["input-field", { active: _ctx.active }])
    }, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : (_ctx.insideLabel)
          ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.insideLabel), 1))
          : _createCommentVNode("", true),
      _createVNode(_component_Multiselect, _mergeProps({
        ref: "select",
        mode: _ctx.mode,
        options: _ctx.options,
        class: {
          error: _ctx.hasError,
          disabled: _ctx.disabled,
          valid: _ctx.valid,
          'has-label': _ctx.label,
        },
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        canClear: _ctx.canClear,
        canDeselect: false,
        searchable: _ctx.searchable,
        nativeSupport: true,
        name: _ctx.name,
        onOpen: _ctx.onFocus,
        onClose: _ctx.onBlur,
        onClear: _ctx.onClear,
        closeOnSelect: _ctx.closeOnSelect,
        modelValue: _ctx.inputValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event))
      }, _ctx.$attrs), {
        multiplelabel: _withCtx(({ values }) => [
          (_ctx.getMultipleLabel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.getMultipleLabel(values.length)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(values.map((v) => v.label).join(",")), 1))
        ]),
        _: 1
      }, 16, ["mode", "options", "class", "placeholder", "disabled", "canClear", "searchable", "name", "onOpen", "onClose", "onClear", "closeOnSelect", "modelValue"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "input-field__error",
          key: index
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ], 2)
  ]))
}